<template>
  <v-snackbar v-model="showSnackbar" color="warning" :timeout="6000" bottom>
    Este menu está temporariamente indisponível.
    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" @click="showSnackbar = false">Fechar</v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '../../../components/js/eventBus.js'

export default {
  name: 'MenuAccessBlockWatcher',
  data: () => ({
    showSnackbar: false,
  }),
  computed: {
    ...mapGetters('auth', ['hasToken', 'hasAcesso']),
  },
  watch: {
    hasToken(now, before) {
      if (!(now && !before)) return
      if (this.hasAcesso) {
        this.ActionCheckBlockedRoutes()
        this.ActionStartBlockPolling()
      }
    },
    hasAcesso(now, before) {
      // Não dispara a checagem aqui: `hasAcesso` fica `true` assim que
      // SelecionarPeriodo.vue chama ActionSetAcesso (síncrono), mas o token
      // com a instituição/período de fato embutidos só é salvo depois, no
      // ActionSetToken dentro do .then() da chamada auth/selected — nesse
      // meio-tempo o backend ainda não reconhece o contexto (401). A troca
      // de rota para 'home' só acontece depois do token novo já estar
      // salvo, então o watch de '$route.path' abaixo é o gatilho seguro.
      if (!now && before) {
        this.ActionStopBlockPolling()
      }
    },
    '$route.path'() {
      if (this.hasToken && this.hasAcesso) {
        this.ActionCheckBlockedRoutes()
        this.ActionStartBlockPolling()
      }
    },
  },
  mounted() {
    if (this.hasToken && this.hasAcesso) {
      this.ActionCheckBlockedRoutes()
      this.ActionStartBlockPolling()
    }
    eventBus.$on('menu-access-block:blocked-nav-attempt', this.onBlockedNavAttempt)
  },
  beforeDestroy() {
    this.ActionStopBlockPolling()
    eventBus.$off('menu-access-block:blocked-nav-attempt', this.onBlockedNavAttempt)
  },
  methods: {
    ...mapActions('menuAccessBlock', [
      'ActionCheckBlockedRoutes',
      'ActionStartBlockPolling',
      'ActionStopBlockPolling',
    ]),
    onBlockedNavAttempt() {
      this.showSnackbar = true
    },
  },
}
</script>
